import { Button, Icon, TextField } from '@nike/eds'
import { VirtualKeyboard } from 'components/keyboard'
import { UnitDetailsPanel } from 'components/left-detail-panel'
import { MainPanel } from 'components/main-panel'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { type Unit } from 'types'
import { getAcceptableToteLpnLengths } from 'utils/goodsholderContext'
import { type ApiHandlerContext } from 'utils/useApiHandler'

interface ScanToteProps {
  unitData: Unit
  handleReturn: () => void
  updateUnitToteScanContext: ApiHandlerContext<Unit>
}

const ACCEPTABLE_TOTE_LPN_LENGTHS = getAcceptableToteLpnLengths()
const MAX_LENGTH = Math.max(...ACCEPTABLE_TOTE_LPN_LENGTHS)

export const ScanTote = ({ unitData, handleReturn, updateUnitToteScanContext }: ScanToteProps) => {
  const { t } = useTranslation()

  const [toteBarcode, setToteBarcode] = useState('')

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    e.stopPropagation()
    // Use setTimeout to ensure state updates complete before validation
    setTimeout(() => {
      handleConfirm()
    }, 0)
  }

  const handleConfirm = () => {
    if (ACCEPTABLE_TOTE_LPN_LENGTHS.includes(toteBarcode.length) && !updateUnitToteScanContext.isLoading) {
      updateUnitToteScanContext.handleApiCall({
        ...unitData,
        toteBarcode,
        status: 'HANDLED'
      })
    }
  }

  const leftPanelContent = <UnitDetailsPanel unit={unitData} showImage={false} />

  const mainPanelContent = <div style={{ display: '-webkit-box' }} className="flex flex-col w-full">
    <div style={{ width: '900px' }} className={'flex-grow m-auto scanTitle'}>
      <form onSubmit={handleSubmit}>
        <TextField
          id="toteBarcode"
          label={t('scan_tote.label')}
          placeholder={t('scan_tote.placeholder')}
          value={toteBarcode}
          onChange={(e) => {
            setToteBarcode(e.currentTarget.value)
          }}
          autoFocus
          maxChars={MAX_LENGTH}
          hasErrors={toteBarcode.length > 0 && !ACCEPTABLE_TOTE_LPN_LENGTHS.includes(toteBarcode.length)}
          errorMessage={t('scan_tote.error')}
          onBlur={(e) => { e.target.focus() }}
          beforeSlot={<Icon name="Scan" />}
        />
      </form>
      <div className='absolute w-full max-w-4xl'>
        <VirtualKeyboard text={toteBarcode} setText={setToteBarcode} confirm={handleConfirm} whichKeyboard='numpad' />
      </div>
    </div>
    <Button onClick={handleReturn} className='absolute text-2xl bottom-0' variant='secondary'>
      {t('buttons.return')}
    </Button>
  </div>

  return <MainPanel leftPanelContent={leftPanelContent} mainPanelContent={mainPanelContent} />
}
